const templateUrl = require('./sent-shipment-body.html');

const app = angular.module('msi.shipments.sentShipmentBody', []);

app.component('ogSentShipmentBody', {
  bindings: {
    shipment: '<ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
